import { render, staticRenderFns } from "./DisputePage.vue?vue&type=template&id=075df0d0&scoped=true"
import script from "./DisputePage.vue?vue&type=script&lang=js"
export * from "./DisputePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075df0d0",
  null
  
)

export default component.exports